import { forwardRef } from 'react';
import { CardMedia } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getImageMediumUrl } from '@sda/utils/image';
import { getImageArrayFromField } from '@sda/utils/image/getImageArrayFromField';
import { ImageLoader } from './common/ImageLoader';
import type { MediaProps } from './interfaces';

const useStyles = makeStyles({ name: 'StaticMedia' })(() => ({
  root: {
    position: 'relative',
    width: '100%',
    zIndex: 0,
    userSelect: 'none',
  },
  preserveRatio: {
    aspectRatio: '16 / 9',

    '& img': {
      position: 'absolute',
      top: 0,
    },

    '&::before': {
      content: '""',
      display: 'block',
      paddingTop: '56.25%',
    },
  },
  media: {
    height: '100%',
    width: '100%',
    zIndex: -1,
  },
}));

export const StaticMedia = forwardRef<HTMLImageElement, MediaProps>(({
  fallback, images, title,
  className = '',
  sizeCallback = getImageMediumUrl,
  preserveRatio = true,
  loading = 'lazy',
}, ref) => {
  const { classes, cx } = useStyles();
  const imageArray = getImageArrayFromField(images, fallback);

  return (
    <div
      className={cx(
        classes.root,
        preserveRatio && classes.preserveRatio,
        className,
      )}
    >
      <ImageLoader
        {...imageArray[0]}
        sizeCallback={sizeCallback}
      >
        {(src) => (
          <CardMedia
            alt={title}
            className={classes.media}
            component="img"
            loading={loading}
            src={src}
            ref={ref}
            title={title}
          />
        )}
      </ImageLoader>
    </div>
  );
});
